import { render, staticRenderFns } from "./videoResource.vue?vue&type=template&id=5ab7e110&scoped=true&"
import script from "./videoResource.vue?vue&type=script&lang=js&"
export * from "./videoResource.vue?vue&type=script&lang=js&"
import style0 from "./videoResource.vue?vue&type=style&index=0&id=5ab7e110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7e110",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab7e110')) {
      api.createRecord('5ab7e110', component.options)
    } else {
      api.reload('5ab7e110', component.options)
    }
    module.hot.accept("./videoResource.vue?vue&type=template&id=5ab7e110&scoped=true&", function () {
      api.rerender('5ab7e110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resource/videoResource.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/videoResource.vue
// module id = UMu6
// module chunks = 0